import { render } from "./LightboxOrders.vue?vue&type=template&id=24dc5510&scoped=true"
import script from "./LightboxOrders.vue?vue&type=script&lang=js"
export * from "./LightboxOrders.vue?vue&type=script&lang=js"

import "./LightboxOrders.vue?vue&type=style&index=0&id=24dc5510&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24dc5510"]])

export default __exports__